import { List } from 'immutable'
import * as authActions from '../auth/actions'
import * as actions from './actions'
import User from './User'
import { Record } from '../transit'
import { ListMeta } from '../lib/redux-lists'

const State = Record({
  viewer: null,
  meta: new ListMeta(),
  all: new List(),
  current: new User(),
}, 'users')

const usersReducer = (state = new State(), action) => {
  if (action.type.endsWith('_ERROR')) {
    let clearViewer = false
    const errors = (action.payload && action.payload.errors) || action.payload
    if (errors && errors.length > 0) {
      errors.forEach(error => {
        if (error.status === 401) {
          clearViewer = true
        }
      })
    }
    if (clearViewer) {
      return state.set('viewer', null)
    }
    return state
  }
  switch (action.type) {
    case authActions.SIGN_OUT: {
      return state.set('viewer', null)
    }
    case authActions.SIGN_IN_SUCCESS: {
      const user = new User(action.payload.data)
      return state.set('viewer', user)
    }
    case actions.USERS_LOAD_SUCCESS: {
      const users = List(action.payload.data.map(json => new User(json)))
      return state.set('all', users).set('meta', new ListMeta(action.payload.meta))
    }
    case actions.USERS_ACTIVE_LOAD_SUCCESS: {
      const users = List(action.payload.data.map(json => new User(json)))
      return state.set('all', users).set('meta', new ListMeta(action.payload.meta))
    }
    case actions.USER_LOAD_SUCCESS: {
      const user = new User(action.payload.data)
      return state.set('current', user)
    }
    case actions.USER_UPDATE_SUCCESS: {
      const user = new User(action.payload.data)
      return state.set('current', user)
    }
    case actions.USER_DELETE_SUCCESS: {
      const list = state.get('all')
      const { _id } = action.payload.data
      const index = list.findIndex((item) => item._id === _id)
      return state.set('all', list.remove(index))
    }
    case actions.CLEAR_USERS: {
      return state.set('all', new List()).set('meta', new ListMeta())
    }
    case actions.CLEAR_USER: {
      return state.set('current', new User())
    }
    default:
      return state
  }
}

export default usersReducer



// WEBPACK FOOTER //
// ./src/common/users/reducer.js